module.exports = __webpack_public_path__ + "img/step3-5.17279645.png";